import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const echoesOfCryptaliaQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "480fa2f5-635a-4d94-9e92-58b6552347c1-wishlist-added",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Watch the Teaser that ignited the spark",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/echoes-of-cryptalia/EchoesOfCryptaliaTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "480fa2f5-635a-4d94-9e92-58b6552347c1-trailer-event",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join Discord of Master Tacticians",
    linkUrl: "https://discord.com/invite/FF4GCYJ3wv",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "480fa2f5-635a-4d94-9e92-58b6552347c1-discord-event",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Echoes of Cryptalia on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "480fa2f5-635a-4d94-9e92-58b6552347c1-twitter-follow-event",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-twitter-follow",
    linkUrl: "https://x.com/PlayCryptalia/",
  },
];

const echoesOfCryptaliaQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Join our Loyalty Program minigame for a chance on NFTs",
    caption: "",
    linkUrl: "https://loyalty.cryptalia.quest/",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "480fa2f5-635a-4d94-9e92-58b6552347c1-website-loyalty-program-event",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-website-loyalty-program",
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "website",
    icon: "X",
    label: "Check out our Genesis Mint thread on X",
    caption: "",
    linkUrl: "https://x.com/PlayCryptalia/status/1916737772645224567",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "480fa2f5-635a-4d94-9e92-58b6552347c1-website-genesis-mint-event",
    ruleId: "480fa2f5-635a-4d94-9e92-58b6552347c1-website-genesis-mint",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "A thorough explorer? See our Gamified Staking thesis",
    caption: "",
    linkUrl: "https://cryptalia.gitbook.io/home/game-mechanics",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "480fa2f5-635a-4d94-9e92-58b6552347c1-website-gamified-staking-thesis-event",
    ruleId:
      "480fa2f5-635a-4d94-9e92-58b6552347c1-website-gamified-staking-thesis",
  },
];

export const echoesOfCryptaliaQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: echoesOfCryptaliaQuestsLvl1,
    introModal: {
      title: "You are on your way to Level 1",
      description:
        "Thanks for following <name>. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LgvpbqstJ9-O6o_CrownofKu%CC%88.gif?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Contribute to the lore",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: echoesOfCryptaliaQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making <name> a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6Lg_5bqstJ9-O6s_Emberpitch.gif?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LhAJbqstJ9-O6t_UnbreakableOath-MAINNFT-.gif?auto=format,compress",
    },
  },
];
